import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./SignUp.css";
import bg1 from '../../icons/bg1.jpg';
import bg2 from '../../icons/bg2.jpg';
import bg3 from '../../icons/bg3.jpg';
import logo from '../../icons/logo.png';
import fb from '../../icons/logo-facebook.svg';
import tw from '../../icons/logo-twitter.svg';
import db from '../../icons/logo-dribbble.svg';
import logoMovil from '../../icons/Isologo-blanco.png';
import addPerson from '../../icons/person-add-sharp.svg';


function SignUp() {
    const [currentIndex, setCurrentIndex] = useState(0);

    const images = [bg1, bg2, bg3];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 10000);

        return () => clearInterval(interval);
    });

    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/Inicio');
    };

    return (
        <>
            <div className="general-signin">
                <div
                    className="imagen-big-signin"
                    style={{
                        backgroundImage: `url(${images[currentIndex]})`,
                    }}
                >
                    <img src={logo} alt="logo" />
                </div>
                <div className="contenido-signin">
                    <div className="form-signup">
                        <label>Regístrate gratis</label>
                        <p>Bienvenido a nuestra plataforma de prospección digital. Ingresa tus datos para crear una cuenta en nuestro CRM o <NavLink to={'/sign-in'} className='nav-links-login'>accede  aquí</NavLink> para iniciar sesión.</p>
                        <div className="inputs-logup">
                            <input type="text" name="logUp" placeholder="Nombre" />
                            <input type="text" name="logUp" placeholder="Apellido" />
                            <input type="email" name="logUp" placeholder="Correo" />
                            <input type="text" name="logUp" placeholder="Teléfono" />
                            <select name="logUp" placeholder="Empresa" >
                                <option value="1">Empresa</option>
                                <option value="2">Independiente</option>
                            </select>
                        </div>
                        <button onClick={handleClick}>CREAR CUENTA</button>
                    </div>
                    <div className="footer-login">
                        <div className="logos-login">
                            <img src={fb} alt="fb" />
                            <img src={tw} alt="tw" />
                            <img src={db} alt="db" />
                        </div>
                        <div className="prospectia">
                            Copyright © Prospectia 2020
                        </div>
                    </div>
                </div>
            </div>
            <div className="singnup-movil">
                <div className="logo-signup-movil">
                    <img src={logoMovil} alt="logoMovil" />
                </div>
                <div className="form-signup-movil">
                    <input type="text" name="logUp" placeholder="Nombre" />
                    <input type="text" name="logUp" placeholder="Apellido" />
                    <input type="email" name="logUp" placeholder="Correo" />
                    <input type="text" name="logUp" placeholder="Teléfono" />
                    <select id="slct-movil" name="logUp" placeholder="Empresa" >
                        <option value="1">Empresa</option>
                        <option value="2">Independiente</option>
                    </select>
                    <button onClick={handleClick}>
                        <img src={addPerson} alt="addPerson" />
                        <label>CREAR CUENTA</label>
                    </button>
                    <p>Si ya tienes una cuenta, <NavLink to={'/sign-in'} className="nav-links-movil link">inicia sesión</NavLink> aqui.</p>
                </div>
            </div>
        </>
    )
}

export { SignUp }